import styled, {css} from 'styled-components';
import {RiArrowDropDownLine} from 'react-icons/ri';
import {dropIn} from '../../utils/styles/animation';

interface ItemProps {
  readonly mWidth?: string;
  readonly mHeigth?: string;
  readonly mPadding?: string;
  readonly firstActve?: boolean;
}

export const DropTitle = styled.span<ItemProps>`
  margin-left: 8px;
  font-size: 14px;
  color: #5d6e81;

  ${props => {
    const firstActve = props.firstActve ? `font-weight: 600` : '';
    return css`
       {
        ${firstActve}
      }
    `;
  }}
`;

export const DropAlert = styled.span`
  justify-content: center;
  display: inline-flex;
  border-radius: 4px;
  text-align: center;
  width: max-content;
  margin-left: 8px;
  margin-right: 8px;
  font-size: 13px;
  min-width: 61px;
  color: #ffffff;
  padding: 2px 4px;

  ${props => {
    const color = props.color ? `background-color: ${props.color};` : 'background-color: #afafaf';
    return css`
       {
        ${color}
      }
    `;
  }}
`;

export const DropLenght = styled.span`
  margin-left: 4px;
  font-size: 14px;
  color: #5d6e81;
`;

export const DropIcon = styled(RiArrowDropDownLine)`
  margin-left: auto;
  color: #acb1c0;
  font-size: 30px;
`;

export const HiddenContainer = styled.div<ItemProps>`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 5px 11px 0 rgba(0, 0, 0, 0.09);
  background-color: var(--BackgroundColor);
  border: 1px solid var(--LightGray);
  border-radius: 8px;
  position: absolute;
  display: none;
  max-height: ${props => props.mHeigth};
  min-width: 100%;
  width: fit-content;
  top: 102%;
  left: 0;
  right: 0;
  z-index: 1;
  transition: 0.3s ease;
  overflow-y: auto;

  ${dropIn({time: '250ms', type: 'ease-in-out'})}
`;

export const DropContainer = styled.div<ItemProps>`
  background-color: rgba(255, 255, 255, 0.92);
  border: 1px solid var(--LightGray);
  display: inline-flex;
  align-items: center;
  position: relative;
  border-radius: 8px;
  min-height: 45px;
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  ${props => {
    const mWidth = `min-width: ${props.mWidth};`;
    const mPadding = `padding: ${props.mPadding};`;
    return css`
       {
        ${mWidth}
        ${mPadding}
      }
    `;
  }}

  &:hover ${HiddenContainer} {
    display: block;
  }
`;

export const HiddenItem = styled.div`
  border-top: 1px solid #f0f0f0;
  padding: 10px 10px 10px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &:hover {
    background-color: var(--BackgroundGray);
  }

  &:first-of-type {
    border-top: none;
  }
`;

export const HiddenItemWrapper = styled.div`
  min-width: max-content;
  align-items: center;
  display: flex;
`;

export const HiddenInput = styled.div`
  margin: 4px;
  display: flex;
  justify-content: center;
`;

export const DropLen = styled.span`
  font-size: 14px;
  color: var(--DarkGray);
`;
